import { axios } from '@/lib/axios';
import storage from '@/utils/storage';

import { WalletInput } from '../components/AddWalletForm';
import { CashoutInput } from '../components/CashoutForm';
import { ConvertInput } from '../components/ConvertForm';
import { DepositInput } from '../components/DepositForm';
import { TransferInput } from '../components/TransferForm';

export const getUserWallet = async () => {
  const userId = storage.getUser()._id;
  const resp = await axios.get(`/wallets/user-wallet/${userId}`);
  return resp.data;
};

export const getUserTransacactions = async (filters?: {
  pageSize?: number;
  startDate?: string;
  endDate?: string;
}) => {
  const params: any = { pageSize: filters?.pageSize ?? 20 };
  if (filters?.startDate) params.startDate = filters.startDate;
  if (filters?.endDate) params.endDate = filters.endDate;

  const resp = await axios.get('/transactions/my-transactions/all', {
    params,
  });
  return resp.data;
};

export const deposit = async (payload: DepositInput) => {
  const resp = await axios.post('/wallets/transaction/deposit/paystack', {
    amount: payload.amount,
  });

  return resp.data;
};

// Called once the user lands back on the app after paying on Paystack's
// hosted checkout page — a safety net alongside the webhook, in case the
// webhook is misconfigured, not yet registered, or simply missed.
export const verifyPaystackDeposit = async (reference: string) => {
  const resp = await axios.get(
    `/wallets/transaction/deposit/paystack/verify/${reference}`,
  );
  return resp.data;
};

export const transferFunds = async (payload: TransferInput) => {
  const resp = await axios.post('/wallets/transaction/transfer', payload);

  return resp.data;
};

export const convertFunds = async (payload: ConvertInput) => {
  const resp = await axios.post('/wallets/transaction/convert', payload);

  return resp.data;
};

export const cashout = async (payload: CashoutInput) => {
  const resp = await axios.post('/wallets/transaction/cashout', payload);

  return resp.data;
};

export const addWallet = async (payload: WalletInput) => {
  const resp = await axios.post('/wallets/add-cashout-wallet', payload);

  return resp.data;
};

export const deleteWallet = async (address: string) => {
  const resp = await axios.delete(`/wallets/${address}`);

  return resp.data;
};

export const getUserByWalletId = async (walletId: string) => {
  const resp = await axios.get(`/wallets/user/${walletId}`);
  return resp.data;
};

export const getAllWallets = async () => {
  const resp = await axios.get(`/wallets?pageSize=5000`);
  return resp.data;
};

export const requestTransactionVerificationCode = async (action: string) => {
  const resp = await axios.post('/wallets/transaction/verification-code', {
    action,
  });
  return resp.data;
};
